<template>
    <div class="h-[76px] rounded-[6px] flex mt-4 bg-black bg-opacity-20" v-if="$widgetUI=='OLD-UI'">
        <template v-for="item in audiences">
            <v-radio v-model="audience"
                     :key="item.key"
                     :value="item.code"
                     class="audience-item"
                     :class="{'active' : audience === item.code}">
                <div class="text-center">
                    <template v-if="item.code === $widgetConfig.b2bBase">
                        <svg width="18"
                             height="18"
                             viewBox="0 0 18 18"
                             class="mx-auto mb-1"
                             fill="none">
                            <path
                                d="M14 8V2C14 0.9 13.1 0 12 0H6C4.9 0 4 0.9 4 2V4H2C0.9 4 0 4.9 0 6V16C0 17.1 0.9 18 2 18H7C7.55 18 8 17.55 8 17V14H10V17C10 17.55 10.45 18 11 18H16C17.1 18 18 17.1 18 16V10C18 8.9 17.1 8 16 8H14ZM4 16H2V14H4V16ZM4 12H2V10H4V12ZM4 8H2V6H4V8ZM8 12H6V10H8V12ZM8 8H6V6H8V8ZM8 4H6V2H8V4ZM12 12H10V10H12V12ZM12 8H10V6H12V8ZM12 4H10V2H12V4ZM16 16H14V14H16V16ZM16 12H14V10H16V12Z"
                                fill="#2FB0FF"/>
                        </svg>

                    </template>
                    <template v-if="item.code === $widgetConfig.b2cBase">
                        <svg width="20"
                             height="19"
                             viewBox="0 0 20 19"
                             class="mx-auto mb-1"
                             fill="none">
                            <path
                                d="M19.8048 10.5569C20.1256 10.1418 20.0407 9.54741 19.6256 9.23608L10.5688 2.32081C10.2291 2.06609 9.75741 2.06609 9.42722 2.32081L4.34218 6.20771V5.66052C4.34218 5.14164 3.91764 4.7171 3.39876 4.7171C2.87988 4.7171 2.45534 5.14164 2.45534 5.66052V7.65114L0.37038 9.23608C-0.0447253 9.54741 -0.120199 10.1418 0.19113 10.5569C0.511893 10.972 1.09681 11.0475 1.51192 10.7361L2.45534 10.0191V17.925C2.45534 18.4439 2.87988 18.8684 3.39876 18.8684H9.05928V14.1513C9.05928 13.6324 9.48382 13.2079 10.0027 13.2079C10.5216 13.2079 10.9461 13.6324 10.9461 14.1513V18.8684H16.6066C17.1255 18.8684 17.5501 18.4439 17.5501 17.925V10.0191L18.4841 10.7361C18.8992 11.0569 19.4935 10.972 19.8048 10.5569ZM3.65348 3.77368C2.95535 3.77368 2.46477 3.01895 2.8044 2.40572C3.29498 1.52834 4.21953 0.94342 5.2856 0.94342C5.6441 0.94342 5.96486 0.735868 6.12524 0.443408C6.26676 0.150947 6.59695 0 6.91772 0C7.61585 0 8.10643 0.754736 7.7668 1.36796C7.27622 2.24534 6.35166 2.83026 5.2856 2.83026C4.9271 2.83026 4.60634 3.03781 4.44596 3.33027C4.30444 3.62273 3.97425 3.77368 3.65348 3.77368Z"
                                fill="#2FB0FF"/>
                        </svg>
                    </template>

                    <div>{{ item.title }}</div>
                </div>
            </v-radio>
        </template>
    </div>
    <div v-else class="md:flex justify-between items-center">
        <div class="text-black-50 text-[18px] font-bold  lg:hidden md:text-[18px] my-2">
            Choose leads list
            <help-tip
                content='Select a database to start your search.'
                class="ml-2"
            />
        </div>
        <div class="rounded-[6px] flex w-100 bg-white p-2 gap-2 text-black top-0 lg:w-full" >

            <template v-for="item in audiences">
                <v-radio v-model="audience"
                         :key="item.key"
                         :value="item.code"
                         class="audience-item"
                         :class="{'active' : audience === item.code}">
                    <div class="text-center">
                        <div>{{ item.title }}</div>
                    </div>
                </v-radio>
            </template>
        </div>
        <div class="lg:hidden md:flex sm:hidden my-3 mobile-hidde ">
            <button type="button" class="w-full btn btn-tour" @click="getStartTour()">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 20" fill="none" class="mx-2">
                    <path d="M10.9242 2.73616L11.2157 2.9759C12.3 3.99198 12.9844 5.36938 13.1344 6.85653C13.2974 8.47137 12.8171 10.0853 11.7979 11.3482C11.0968 12.1794 10.6981 13.2237 10.667 14.3107L10.6668 14.3178V14.325V16.6667C10.6668 17.1971 10.4561 17.7058 10.081 18.0809C9.70592 18.4559 9.19722 18.6667 8.66678 18.6667H5.33345C4.80301 18.6667 4.29431 18.4559 3.91923 18.0809C3.54416 17.7058 3.33345 17.1971 3.33345 16.6667L3.33345 14.1667V14.1589L3.33321 14.1511C3.30219 13.1534 2.92371 12.198 2.2633 11.4497C1.68096 10.7463 1.26051 9.92326 1.03182 9.03906C0.802583 8.15277 0.77165 7.22683 0.941219 6.32722C1.17376 5.12822 1.75711 4.02526 2.6173 3.1582C3.47779 2.29085 4.57653 1.69866 5.77411 1.45675L5.77501 1.45657C6.67442 1.27318 7.60342 1.29289 8.49425 1.51426C9.38507 1.73564 10.2152 2.15309 10.9242 2.73616ZM4.50011 15.3333H4.00011V15.8333L4.00011 16.6667C4.00011 17.0203 4.14059 17.3594 4.39064 17.6095C4.64069 17.8595 4.97983 18 5.33345 18H8.66678C9.0204 18 9.35954 17.8595 9.60959 17.6095C9.85964 17.3594 10.0001 17.0203 10.0001 16.6667V15.8333V15.3333H9.50011L4.50011 15.3333ZM11.274 10.9556L11.2741 10.9556L11.2789 10.9498C12.0747 9.97638 12.5066 8.75608 12.5001 7.49877C12.5003 6.68266 12.3189 5.87672 11.9691 5.1394C11.619 4.40163 11.109 3.75107 10.4762 3.23497C9.84331 2.71886 9.10348 2.35015 8.31037 2.15561C7.51726 1.96106 6.69079 1.94557 5.89095 2.11026L5.89041 2.11037C4.95973 2.30305 4.09487 2.73362 3.38014 3.36008C2.66542 3.98655 2.12523 4.78753 1.81224 5.68494C1.49926 6.58234 1.42417 7.54554 1.59428 8.4806C1.7644 9.41567 2.17392 10.2907 2.78291 11.0204L2.78282 11.0204L2.78993 11.0286C3.5516 11.9021 3.98023 13.0165 4.00019 14.1753L4.00865 14.6667H4.50011L6.16678 14.6667H6.66678L6.66678 14.1667V11.6667C6.66678 11.5782 6.7019 11.4935 6.76441 11.431L6.41086 11.0774L6.76441 11.431C6.82693 11.3684 6.91171 11.3333 7.00011 11.3333C7.08852 11.3333 7.1733 11.3684 7.23582 11.431C7.29833 11.4935 7.33345 11.5782 7.33345 11.6667V14.1667L7.33345 14.6667H7.83345H9.50011H9.97575L9.99949 14.1916C10.0589 13.0026 10.5066 11.8658 11.274 10.9556Z" fill="#3B3B3B" stroke="#3B3B3B"/>
                </svg>
                Take a quick tour
            </button>
        </div>
    </div>

</template>

<script>
import RadioList from "./selections/types/radio-list";
import introJS from 'intro.js';
export default {
    name: "audience-static-audience",
    components: {
        RadioList
    },
    computed: {
        audiences () {
            return this.$store.getters["widgetData/getAudienceData"];
        },
        audience: {
            set (value) {
                if (!this.selectsNotEmpty) {
                    this.$store.commit("widgetData/setAudience", value);
                } else {
                    this.$store.commit("others/setConfirmationBase", value);
                    this.$store.commit("others/setLoading", true);
                    this.$store.commit("others/setConfirmationTooltip", true);
                }
            },
            get () {
                return this.$store.getters["widgetData/selectedData"].audience;
            }
        },
        selectsNotEmpty () {
            return this.$store.getters["widgetData/selectedData"].selects.filter(item => !item.code.includes("one_per_address")).length;
        }
    },
    methods:{
        getStartTour(){
            console.log('introJS', introJS().start())
            introJS().setOptions({
                showStepNumbers: true,
                stepNumbersOfLabel: true,
                showBullets:false
            }).start();
        },
    }
};
</script>

<style lang="scss" scoped>
.btn-tour{
    background: #FBEBD4;
    border-radius: 6px;
    display:flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #B1B1B1;
    font-size:16px;

}
</style>
